// | ------------------------------------------------------------------------
// | Main Navigation
// | ------------------------------------------------------------------------ 


import { Modal, Popover} from "bootstrap";


window.addEventListener('load', (event) => {

    // Set variables
    var body = document.querySelector("body");
    var nav = document.querySelector(".main-nav");
    var button = document.querySelector('#mobile-nav-btn');
    var windowWidth = document.body.clientWidth;


    // Toggle menu function
    var toggleDrawer = function(){
        body.classList.toggle('mobile-nav-open');
        button.classList.toggle('toggled');
        document.documentElement.classList.toggle('no-scroll');
        
        // Close all Modals (if there are any) when toggling the menu
        if(document.querySelectorAll('.modal.show').length > 0){
            var modals = document.querySelectorAll('.modal.show');
            modals.forEach(function(e){
                var modal = Modal.getInstance(e)                
                modal.hide();
            });           
        }        

        // Close all Popovers (if there are any) when toggling the menu
        if(document.querySelectorAll('[data-bs-toggle="popover"]').length > 0){
            var popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
            popovers.forEach(function(e){
                var popover = Popover.getInstance(e)
                popover.hide();
            });           
        }
        
        
    }

    if(button){

        // Open/close drawer using menu button
        button.addEventListener("click",function(event){
            event.stopPropagation();
            toggleDrawer();
        }, false); 

        // Prevent menu closing when clicked
        nav.addEventListener("click",function(event){
            event.stopPropagation();
        }, false);         

        // Close drawer when clicking off menu
        body.addEventListener("click",function(){
            if (body.classList.contains('mobile-nav-open')) {
                toggleDrawer();
            }
        }, false);        

        // Close drawer if window is resized
        window.addEventListener("resize",function(){
            if(document.body.clientWidth !== windowWidth){
                if (body.classList.contains('mobile-nav-open')) {
                    toggleDrawer();
                }
            }
            windowWidth = document.body.clientWidth;
        });

    }
});